import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import styles from "./Navbar.module.css";
import ExitIcon from "../../assets/exit.svg";
import Sheet from "../../assets/sheet.svg";
import TemplateSheet from "../../assets/sheet_template.svg";
import ArrowRight from "../../assets/arrow_right.svg";
import TemplateSheetList from "../../assets/list_template.svg"; 
import PdfIcon from "../../assets/pdf_icon.svg"; 
import theme from '../../themes/ThemeLoader';
import {AuthContext} from "../../context/AuthContext";
import {ProductContext} from "../../context/ProductContext";
import {ExpiredProductContext} from "../../context/ExpiredProductContext";
import {StoresContext} from "../../context/StoresContext";
import {UserContext} from "../../context/UserContext";
import {AdminRoutes} from "../../utils/AdminRoutes";
import {useModal} from '../../context/ModalContext';
import SearchIcon from "../../assets/search.svg";
import {searchProductsByStore} from "../../hooks/Product";
import {searchExpiredProductsByStore} from "../../hooks/ExpiredProduct";
import {
  HOME_ROUTE,
  PRODUCTS_ROUTE,
  EXPIRED_PRODUCTS_ROUTE,
  USERS_ROUTE,
  SETTINGS_ROUTE,
  ADMIN_ROUTE,
  ADMIN_STORES_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_IMPORT_ROUTE,
  ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
  ADMIN_SETTINGS_ROUTE
} from '../../utils/Constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Navbar = () => {
  const { logout } = useContext( AuthContext );
  const { setResearchProducts } = useContext( ProductContext );
  const { setResearchExpiredProducts, expiredproductIds } = useContext( ExpiredProductContext );
  const { selectedStore } = useContext( StoresContext );
  const { userIds } = useContext( UserContext );
  const { pathname } = useLocation();
  const [ searchTerm, setSearchTerm ] = useState("");
  const adminRoute = AdminRoutes().includes(pathname);
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  const handleLogout = () => { 
    logout();

    if (adminRoute) {
      navigate(ADMIN_ROUTE);
    } else {
      navigate(HOME_ROUTE);
    }
  }

  const searchProducts = async () => {
    if (!selectedStore || !selectedStore.id) {
      setResearchProducts([])
      return;
    }

    if (!searchTerm.trim()) {
      setResearchProducts([])
      return;
    }
    try {
        const productData = await searchProductsByStore( selectedStore.id, searchTerm );
        if (productData) {
          setResearchProducts(productData.data);
        }else {
          setResearchProducts([])
        }

    }catch(err) {
        setResearchProducts([])
        console.error("Error to search products:", err);
    }
  };

  const searchExpiredProducts = async () => {
    if (!selectedStore || !selectedStore.id) {
      setResearchExpiredProducts([])
      return;
    }

    if (!searchTerm.trim()) {
      setResearchExpiredProducts([])
      return;
    }
    try {
        const productData = await searchExpiredProductsByStore( selectedStore.id, searchTerm );
        if (productData) {
          setResearchExpiredProducts(productData.data.data);
        }else {
          setResearchExpiredProducts([])
        }

    }catch(err) {
      setResearchExpiredProducts([])
        console.error("Error to search products:", err);
    }
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const { 
    openImportModal,
    openImportSheetModal,
    openExportSheetModal,
    openImportListModal,
    openTransferModal,
    openExportPdfModal,
  } = useModal();

  
  const handleTransferModal = () => {
    console.log("userIds", userIds)
    if (expiredproductIds?.length >= 1 && userIds?.length === 1) {
      openTransferModal()
    }else {
      toast.warning("Selecione algum produto e apenas um usuário para transferência.")
      setError(true);
    }

  }

  const renderNavItems = () => {

    switch (pathname) {
      case ADMIN_IMPORT_ROUTE:
        return (
          <>
           <div className={styles.navItem} onClick={ openImportModal }>
              <img src={TemplateSheet} alt="Criar template de Importação" className={styles.navIcon} />
              <span className={styles.navText}>Criar Template</span>
            </div>

            <div className={styles.navItem} onClick={ openImportListModal }>
              <img src={TemplateSheetList} alt="Lista de Templates" className={styles.navIcon} />
              <span className={styles.navText}>Lista de Templates</span>
            </div>

            <div className={styles.navItem} onClick={ openImportSheetModal }>
              <img src={Sheet} alt="Importar Planilha" className={styles.navIcon} />
              <span className={styles.navText}>Importar Planilha</span>
            </div>

            <div className={styles.navItem} onClick={ openExportSheetModal }>
              <img src={Sheet} alt="Exportar Planilha" className={styles.navIcon} />
              <span className={styles.navText}>Exportar Planilha</span>
            </div>
          </>
        );

        case ADMIN_EXPIRY_DATE_CONTROL_ROUTE:
          return (
            <>
            <div className={styles.navItem}>
                <div className={styles.filterItems} onClick={ handleTransferModal }>
                  <span>Transferir Produtos </span>
                  <img src={ArrowRight} alt="Filtros"/>
                </div>
              </div>

              {<div className={styles.navItem} onClick={ openExportPdfModal }>
                <img src={ PdfIcon } alt="Exportar Pdf" className={styles.navIcon} />
                <span className={styles.navText}>Exportar PDF</span>
              </div> }

              <div className={styles.navItem} onClick={ openExportSheetModal }>
                <img src={Sheet} alt="Exportar Planilha" className={styles.navIcon} />
                <span className={styles.navText}>Exportar Planilha</span>
              </div>
            </>
          );

      default:
        return null;
    }
  }

  const renderAdminSearchBar = () => {
    switch (pathname) {
      case ADMIN_IMPORT_ROUTE:
        return (
          <>
           <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Pesquise..."
              value={ searchTerm }
              onChange={ handleSearchChange }
            />
            <img src={ SearchIcon } 
            alt="Ícone de Pesquisa" 
            className={styles.searchIcon} 
            onClick={ searchProducts }
            />
        </div>
          </>
        );
      
      case ADMIN_EXPIRY_DATE_CONTROL_ROUTE :
        return (
          <>
           <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Pesquise..."
              value={ searchTerm }
              onChange={ handleSearchChange }
            />
            <img src={ SearchIcon } 
            alt="Ícone de Pesquisa" 
            className={styles.searchIcon} 
            onClick={ searchExpiredProducts }
            />
        </div>
        </>
    );
      default:
        return null;
    }
  }

  const renderSearchBarForUserPanel = () => {
    switch (pathname) {
      case PRODUCTS_ROUTE:
        return (
          <div className={styles.searchPosition}>
           <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.searchInput}
              placeholder="Pesquise..."
              value={ searchTerm }
              onChange={ handleSearchChange }
            />
            <img src={ SearchIcon } 
            alt="Ícone de Pesquisa" 
            className={styles.searchIcon} 
            onClick={ searchProducts }
            />
        </div>
      </div>
    );

    case EXPIRED_PRODUCTS_ROUTE :
      return (
        <div className={styles.searchPosition}>
         <div className={styles.searchContainer}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Pesquise..."
            value={ searchTerm }
            onChange={ handleSearchChange }
          />
          <img src={ SearchIcon } 
          alt="Ícone de Pesquisa" 
          className={styles.searchIcon} 
          onClick={ searchExpiredProducts }
          />
      </div>
    </div>
  );

      default:
        return null;
    }
  }

  const renderStoreTitle = () => {
    switch (pathname) {
      case PRODUCTS_ROUTE:
        return ( <> <h1 id={styles.storeTitle}>{`LOJA ${selectedStore?.name}`}</h1> </> );

    case USERS_ROUTE:
        return ( <> <h1 id={styles.storeTitle}>{`LOJA ${selectedStore?.name}`}</h1> </> );

    case EXPIRED_PRODUCTS_ROUTE:
      return ( <> <h1 id={styles.storeTitle}>{`LOJA ${selectedStore?.name}`}</h1> </> );

    case SETTINGS_ROUTE:
      return ( <> <h1 id={styles.storeTitle}>{`LOJA ${selectedStore?.name}`}</h1> </> );

      case ADMIN_SETTINGS_ROUTE:
        return ( <> <h1 id={styles.storeTitle}>Configurações</h1> </> );

      default:
        return null;
    }
  }


  return (
    <div 
      className={styles.navbarContainer} 
      style={{ backgroundColor: theme.navbarBackgroundColor }}>

        { error && <ToastContainer/>}
        { renderStoreTitle() }
        { renderSearchBarForUserPanel() } 
       

      <div className={styles.navItems}>
        { renderAdminSearchBar() }

        { renderNavItems() }

      </div>

      <div className={styles.exitIcon} onClick={handleLogout}>
      <img src={ExitIcon} alt="Sair" />
      <span className={styles.navLink}>Sair</span>
    </div>

      
    </div>
  );
};

export default Navbar;
